import calls from '@/backend/api-calls'

const state = () => ({
  delivery: null,
  selected: [],
  allSelected: false,
  firstLoad: true,
  loading: false
})

// getters
const getters = {
  ids: state => {
    return state.delivery.delivery_storages.map(d => d.id);
  }
}

// actions
const actions = {
  getDelivery: ({commit}, deliveryId) => {
    commit("setLoading", true);

    return new Promise((resolve, reject) => {
      calls.delivery.get(deliveryId)
        .then(resp => {
          commit("setDelivery", resp.data);
          commit("setLoading", false);
          commit("setFirstLoad", false);
          resolve(resp);
        }).catch(err => {
          commit("setLoading", false);
          reject(err);
        })
    })
  },
  getDeliveryStorage: ({commit, getters}, itemId) => {
    return new Promise((resolve, reject) => {
      calls.deliveryStorage.get(itemId).then(
        resp => {
          if (getters.ids.includes(resp.data.id)) {
            commit("insertUpdatedItem", resp.data);
          } else {
            commit("insertDeliveryItem", resp.data);
          }
          resolve(resp);
        }
      ).catch(err => reject(err));
    })
  },
  updateDelivery: ({commit}, { deliveryId, data }) => {
    return new Promise((resolve, reject) => {
      calls.delivery.put(deliveryId, data)
        .then(resp => {
          commit("setDelivery", resp.data);
          commit("app/setNotification", {
            type: 'success',
            status: true,
            message: 'Delivery successfully updated'
          }, { root: true });
          
          resolve(resp);
        }).catch(err => {
          reject(err);
        })
    })
  },
  addImages: ({commit}, { deliveryId, data }) => {
    return new Promise((resolve, reject) => {
      calls.delivery.addImage(deliveryId, data).then(
        resp => {
          commit("setDelivery", resp.data);
          resolve(resp);
        }
      ).catch(err => reject(err));
    })
  },
  addItem: ({commit}, item) => {
    return new Promise((resolve, reject) => {
      calls.deliveryStorages.post(item).then(
        resp => {
          commit("insertDeliveryItem", resp.data);
          commit("app/setNotification", {
            type: 'success',
            status: true,
            message: 'Order item successfully added'
          }, { root: true });
          resolve(resp);
        }
      ).catch(err => reject(err));
    })
  },
  updateItem: ({commit}, { itemId, data }) => {
    return new Promise((resolve, reject) => {
      calls.deliveryStorage.put(itemId, data).then(
        resp => {
          commit("insertUpdatedItem", resp.data);
          commit("app/setNotification", {
            type: 'success',
            status: true,
            message: 'Delivery successfully updated'
          }, { root: true });
          resolve(resp);
        }
      ).catch(err => reject(err));
    })
  },
  deleteItem: ({commit}, itemId) => {
    return new Promise((resolve, reject) => {
      calls.deliveryStorage.delete(itemId).then(
        resp => {
          commit("removeDetail", itemId);
          commit("app/setNotification", {
            type: 'success',
            status: true,
            message: 'Item successfully deleted'
          }, { root: true });
          resolve(resp);
        }
      ).catch(err => reject(err));
    })
  },
  toggleAllSelected: ({commit, getters}, value) => {
    if (value) {
      commit("selectAll", getters.ids);
    } else {
      commit("deselectAll");
    }
  }
}

// mutations
const mutations = {
  setFirstLoad(state, status) {
    state.firstLoad = status;
  },
  setLoading(state, status) {
    state.loading = status;
  },
  setDelivery(state, data) {
    state.delivery = data;
  },
  insertDeliveryItem(state, item) {
    state.delivery.delivery_storages.push(item);
  },
  insertUpdatedItem(state, item) {
    state.delivery.delivery_storages.forEach((deliveryItem, i) => {
      if (deliveryItem.id == item.id) {
        state.delivery.delivery_storages.splice(i, 1, item);
      }
    })
  },
  removeItem(state, itemId) {
    state.delivery.delivery_storages.forEach((item, i) => {
      if (item.id == itemId) {
        state.delivery.delivery_storages.splice(i, 1);
      }
    })

    let index = state.selected.indexOf(itemId);
    if (index != -1) {
      state.selected.splice(index, 1);
    }
  },
  selectAll(state, ids) {
    state.allSelected = true;
    ids.forEach(id => {
      if (state.selected.indexOf(id) == -1) {
        state.selected.push(id);
      }
    })
  },
  deselectAll(state) {
    state.allSelected = false;
    state.selected.splice(0, state.selected.length)
  },
  toggleSelected(state, id) {
    const index = state.selected.indexOf(id);

    if (index == -1) {
      state.selected.push(id);
    } else {
      state.selected.splice(index, 1);
      if (state.selected.length == 0) {
        state.allSelected = false;
      }
    }
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}